import { Chip } from 'primereact/chip';
import React, { MouseEvent } from 'react';

import { LinkAttachement } from '../../../pages/mindmap/types';
import { useMindmap } from '../../../pages/mindmap/use-mindmap';

interface LinkAttachementChipProps {
  id?: string;
  attachement: LinkAttachement;
  selected: boolean;
  nodeId?: string;
}

export const LinkAttachementChip = ({ id, attachement, selected, nodeId }: LinkAttachementChipProps) => {
  const {
    contextMenu: { setActiveMenu },
    interactableMap: { positionContextMenu },
  } = useMindmap();

  const onClick = (e: MouseEvent) => {
    if (selected && nodeId) {
      positionContextMenu(e, false);
      setActiveMenu({ type: 'edit-link-attachement', nodeId, attachement });

      // prevent registration as map or node click
      e.preventDefault();
      e.stopPropagation();
    } else {
      // open link
      window.open(attachement.url);
    }
  };

  return (
    <Chip id={id} className="attachement-chip" icon="pi pi-external-link" label={attachement.name} onClick={onClick} />
  );
};
